import { IOption } from '@/types/global.ts'
import { IAlarmSituation } from '../../alarmSituations.types.ts'

const fieldTypeOptions: IOption<IAlarmSituation['level']>[] = [
  { title: 'Не выбрано', value: null },
  { title: 'Предупреждение', value: 'WARNING' },
  { title: 'Опасность', value: 'DANGER' },
  { title: 'Критично', value: 'CRITICAL' },
]

const AlarmSituationsDataTypeDropdownStatusConstants = { fieldTypeOptions }
export default AlarmSituationsDataTypeDropdownStatusConstants
